import React, {useEffect, useState} from 'react';
import RequestsPurchaseTableItem from "../../../../components/UI/table/warehouse/purchase/RequestsPurchaseTableItem";
import {useNavigate, useParams} from "react-router-dom";
import {BreadcrumbsComponent} from "../../../../components/UI/breadcrumb/BreadcrumbComponent";
import {Box} from "@mui/system";
import Typography from "@mui/material/Typography";
import {estimateStatuses} from "../../../../data/EstimateState";
import {Paper} from "@mui/material";
import ButtonSelectAction from "../../../../components/UI/button/ButtonSelectAction";
import {ModalSelectAction} from "../../../../components/UI/modal/ModalSelectAction";
import MaterialEstimateUnitService from "../../../../API/orders/estimate/organization/MaterialEstimateUnitService";
import {EditLocalStoragePagesData} from "../../../../utils/EditLocalStoragePagesData";
import EstimateService from "../../../../API/orders/estimate/organization/EstimateService";
import {constantsErrorMessages} from "../../../../Constants";
import ModalAlert from "../../../../components/UI/table/customer-detales/ModalAlert";
import DetailUtil from "../../../../utils/cutting/DetailUtil";
import UnitService from "../../../../API/orders/warehouse/UnitService";
import MaterialReserveService from "../../../../API/orders/reservation/MaterialReserveService";
import {calcFilterData} from "../../../../utils/common/calcFilterData";
import OrderUtil from "../../../../utils/orders/OrderUtil";
import {materialEstimateUnitStates} from "../../../../data/MaterialEstimateUnitState";
import {RequestsPurchaseItemFilterData} from "../../../../data/FilterTables/RequestsPurchaseItemFilterData";

const RequestsPurchaseItem = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [rowSelection, setRowSelection] = useState([]);
    const [data, setData] = useState([]);
    const [open, setOpen] = useState(false)
    const [alertData, setAlertData] = useState({});
    const [errorIds, setErrorIds] = useState([]);
    const [unitMap, setUnitMap] = useState({});
    const [statusList, setStatusList] = useState([]);
    const [globalFilter, setGlobalFilter] = useState('');
    const [filteredData, setFilteredData] = useState(data)
    const [columnsFilter, setColumnsFilter] = useState([]);
    const [loading, setLoading] = useState(false)
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`organization/requests-purchase`, "pageSize", nextState.pageSize)
        }
    }
    const statusIgnore = ["EXECUTION_OF_APPLICATION", "RECONCILIATION_OF_DATA", "WAITING_FOR_DELIVERY", "IN_STOCK", "ARCHIVE", "ISSUED"]

    const handleSubmitSetPurchase = async (all, createReserves, setSetPurchaseModalOpen, ignoreSlab) => {
        setLoading(true)
        const api = createReserves ? EstimateService.createReservesForPurchase : EstimateService.setPurchase
        api(orderId, all ? {
            "ids": null
        } : {
            "ids": rowSelection
        }, ignoreSlab, estimateId)
            .then(function (response) {
                const newData = data.map(el => {
                    if (createReserves) {
                        return rowSelection.includes(el.id) || all ? {
                            ...el,
                            materialEstimateUnitState: "CREATED_RESERVES"
                        } : el
                    } else {
                        return (rowSelection.includes(el.id) || all) && (!statusIgnore.includes(el.materialEstimateUnitState)) ? {
                            ...el,
                            materialEstimateUnitState: "WAITING_FOR_AN_APPLICATION"
                        } : el
                    }
                })
                setData(newData)
                handleSearchQuery(globalFilter, newData)
                all ? setSetPurchaseModalOpen(false) : setOpen(false)
                setRowSelection([])
                navigate("/organization/requests-purchase");
                createReserves ? navigate("/organization/requests-purchase/" + estimateId + '/' + orderId + '/' + orderNumber + '/' + "CREATED_RESERVES") : navigate("/organization/requests-purchase/" + estimateId + '/' + orderId + '/' + orderNumber + '/' + "PURCHASE")
                handleModalAlert(createReserves ? "Cозданы резервы" : "Отправлено на закупку", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setLoading(false))
    }
    const modalActions = [
        {name: "Создать резервы", type: "reserve"},
        {name: "Отправить на закупку", type: "purchase"},
        {name: "Удалить резервы", type: "delete"},
    ]


    const handleSelectAction = (type) => {
        if (type === "reserve") {
            return handleSubmitSetPurchase(false, true, null, false)
        } else if (type === 'delete') {
            setLoading(true)
            MaterialEstimateUnitService.deleteReservesByIds(rowSelection).then(function (response) {
                setRowSelection([])
                setOpen(false)
                const newData = data.map(el => ({
                    ...el,
                    materialEstimateUnitState: response.data.find(respEl => respEl.id === el.id)?.materialEstimateUnitState || el.materialEstimateUnitState
                }))
                setData(newData)
                handleSearchQuery(globalFilter, newData)
                handleModalAlert("Резервы удалены", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                })
                .finally(() => setLoading(false))
        } else {
            return handleSubmitSetPurchase(false, false)
        }

    }
    const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
        const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
        const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

        const data = [...prevData]
        const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, RequestsPurchaseItemFilterData, unitMap) : data
        const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
            return calcFilterData(accumulator, currentValue?.value, [RequestsPurchaseItemFilterData.find(el => el.idFromColumnFilter === currentValue.id)], unitMap)
        }, globalFilterData);

        setFilteredData(newData)

        tableOptionsHandle({
            ...tableOptions,
            totalElements: newData.length,
            pageSize: pageSize ? pageSize : tableOptions?.pageSize
        })

        if (isColumnFilters) {
            setColumnsFilter(searchQuery)
        } else {
            setGlobalFilter(searchQuery || "")
            if (searchQuery !== globalFilter) {
                EditLocalStoragePagesData(`organization/requests-purchase`, "searchQuery", searchQuery)
            }
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`organization/requests-purchase`]?.pageSize
        const searchQuery = pagesData[`organization/requests-purchase`]?.searchQuery

        return {searchQuery, pageSize}
    }

    const estimateId = params.estimateId;
    const orderId = params.orderId;
    const orderNumber = params.orderNumber;
    const status = params.status

    useEffect(() => {
        const {searchQuery, pageSize} = getStartPageSize()
        UnitService.getAll()
            .then(function (response) {
                let data = response.data;
                const unitMapData = data.reduce((acc, el) => ({...acc, [el.id]: el.name}), {})
                setUnitMap(unitMapData)
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => {
                MaterialEstimateUnitService.getAllByOrderIdForRequestsPurchase(orderId).then(function (response) {
                    let data = response.data;
                    setData(data);
                    const error = DetailUtil.checkDuplicateNames(data);

                    if (error.length > 0) {
                        setErrorIds(error)
                    }
                    setStatusList(OrderUtil.getListFieldByEnum(data, 'materialEstimateUnitState', materialEstimateUnitStates));
                    handleSearchQuery(searchQuery, data, pageSize)
                })
                    .catch(function (error) {
                        handleModalAlert(error);
                    });
            })
    }, []);
    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"Заявка на заказ"}
                path={[
                    {name: "Главная", href: "/"},
                    {name: "Заявки на закупку", href: "/organization/requests-purchase"},
                ]}/>
            <Box sx={{display: "flex", flexDirection: "column", gap: "32px"}}>
                <Box sx={{display: "flex", flexDirection: "column"}}>
                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                        Заявка на заказ {orderNumber}
                    </Typography>
                    <Typography>{`Статус: ${estimateStatuses[status]}`}</Typography>
                </Box>
                <RequestsPurchaseTableItem
                    estimateId={estimateId}
                    orderId={orderId}
                    orderNumber={orderNumber}
                    status={status}
                    rowSelection={rowSelection}
                    setRowSelection={setRowSelection}
                    data={data}
                    setData={setData}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    handleSubmitSetPurchase={handleSubmitSetPurchase}
                    handleModalAlert={handleModalAlert}
                    errorIds={errorIds}
                    unitMap={unitMap}
                    statusList={statusList}
                    globalFilter={globalFilter}
                    handleSearchQuery={handleSearchQuery}
                    filteredData={filteredData}
                    columnsFilter={columnsFilter}
                    loading={loading}
                />
                {Object.keys(rowSelection).length !== 0 && <Paper sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: "88px",
                    display: 'flex',
                    justifyContent: "center",
                    alignItems: 'center',
                    backgroundColor: (theme) => theme.palette.primary.lightGrey,
                }} component="footer">
                    <ButtonSelectAction text={"Выбрать действие"} onClick={() => setOpen(true)}/>
                </Paper>}
                <ModalSelectAction
                    open={open}
                    reset={() => setOpen(false)}
                    submit={handleSelectAction}
                    modalActions={modalActions}
                    loading={loading}
                />
                <ModalAlert
                    data={alertData}
                    onClose={() => setAlertData((alert) => ({...alert, open: false}))}
                />
            </Box>
        </Box>
    );
};

export default RequestsPurchaseItem;